import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { SpinnerVisibilityService } from 'ng-http-loader';
import Swal from 'sweetalert2'
import { BMApiService } from '../../../../services/bm.service';
import { Router, Params, ActivatedRoute } from '@angular/router';
import { UserService } from '../../../../services/user.service';
import { HttpClient } from '@angular/common/http';
import {
  AngularGridInstance,
  Column,
  FieldType,
  Filters,
  Formatter,
  GridOption,
  FileType,
  Formatters,
  GridStateChange,

  MenuCallbackArgs
} from 'angular-slickgrid';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { UtilityService } from '../../../../services/utility.service';
import { AdminApiService } from '../../../../services/admin.service';
import { tranbenchmarkkpi, tranbenchmarkkpihistory, benchmarkkpirelease, bmdashboardFilterValue, year, dashboardContentEntry, dashboardChart } from '../../../../models/slakpi';
import { division, department } from '../../../../models/admin';
import { ToasterService } from '../../../../toaster.service';

declare var google: any;
import { uniqBy } from 'lodash';
@Component({
  selector: 'app-practice-bm-dashboard',
  templateUrl: './practice-bm-dashboard.component.html',
  styleUrls: ['./practice-bm-dashboard.component.css']
})
export class PracticeBMDashboardComponent implements OnInit {

  chartOptionpracticebmdashboardchart01: any = {};
  chartOptionpracticebmdashboardchart02: any = {};
  public gridApi;
  public gridColumnApi;
  divisionUno = 0;
  public columnDefs;
  public defaultColDef;
  public rowData: [];
  public businessDivisionUno: any;
  public businessDeptUno: any;
  public trendUno: any;
  public yearUno: any;
  public division_data: any;
  public department_data: any;
  public trend_data: any;
  public yearData: any;

  public count_data: any;
  public position_data: any;
  public peer_data: any;
  public map_data: any;

  public permision_add: boolean = false;
  public permision_edit: boolean = false;
  public permision_delete: boolean = false;
  user: any = {};
  login_UserID: string; // number
  isAdmin: boolean = false;
  public isBMChambion: boolean = false;
  public isBMTeam: boolean = false;
  public isBMVisitor: boolean = false;
  public isBMAdmin: boolean = false;
    multipleDashboardContent: any=[];
    selectedEditItem: any;
    selectedEditItemIndex: any;
    dashkbtn: string='Add';
    isSubmitted: boolean;
  modalRef: BsModalRef;

  objDashboard: any = new dashboardContentEntry();
  @ViewChild('dashboardContentAddEdit', { static: false }) dashboardContentAddEdit: TemplateRef<any>;
    title: string;
    isAddentry: boolean;
    dashboardType: any;
    data: any;
    dataset: any[];
    editID: any;
  columnDefinitions: any;
  gridOptions: GridOption;
  angularGrid: AngularGridInstance;
    projectContent: any;
    outgoingContent: any;
  progressCountList: Object;

  practiceBMTrackingList: any;
    gridShow: boolean=false;
  constructor(public restApi: BMApiService, public restAdminApi: AdminApiService, private toaster: ToasterService, public utilityService: UtilityService, private router: Router, private spinner: SpinnerVisibilityService, private userService: UserService, private modalService: BsModalService) {
    //To Validate User Permission
    this.user = this.userService.getUserInfo();
    this.login_UserID = this.user.id;
    this.yearUno = Number(this.user.currentYear);
    this.ValidateUserAccess();
  }

  //Method used To Validate User Permission
  ValidateUserAccess() {

    
    this.isAdmin = (this.user.role == 'Administrator' || this.user.role == 'BM Administrator') ? true : false;
    // this.CheckUserPermission();
    if (this.user.role == 'BM Champions')
      this.isBMChambion = true;
    if (this.user.role == 'BM Team')
      this.isBMTeam = true;
    if (this.user.role == 'BM Visitor')
      this.isBMVisitor = true;
    if (this.user.role == 'BM Administrator') { this.isBMAdmin = true; }

    //if (!this.isAdmin && !this.isBMChambion && !this.isBMTeam && !this.isBMVisitor && !this.isBMAdmin)
    //  this.router.navigateByUrl('/access-denied');
    if (!this.isAdmin) {
      let userPermissionData = this.userService.getUserRights("Practice BM Dashboard");
      if (userPermissionData != null && userPermissionData != undefined && userPermissionData.length > 0) {
        if (userPermissionData[0].showPage == 1) {

        }
        else {
          this.router.navigateByUrl('/access-denied');
        }
      }
    }
  }

  ngOnInit() {
    this.userService.CheckLogin();
    this.gridOptions = {
      autoHeight: true,
      enableAutoResize: true,
      enablePagination: true,
      pagination: {
        pageSizes: [5, 10, 20, 50, 100, 500],
        pageSize: 20
      },
      enableFiltering: true,
      alwaysShowVerticalScroll: false,
      enableRowSelection: true,
      autoResize: {
        containerId: 'musherat-grid',
        delay: 0,
        sidePadding: 10,
        bottomPadding: 10
      },
      enableExcelExport: true,
      enableExcelCopyBuffer: true,
      enableFilterTrimWhiteSpace: true,
      showCustomFooter: true, // display some metrics in the bottom custom footer
      enableContextMenu: true,
      enableCellMenu: true,
      forceFitColumns: true,

    };
    this.businessDeptUno = 0;
    this.businessDivisionUno = 0;
    this.trendUno = 0;
    this.loadFilterValues();
    this.getDivisions();
    //this.getDepartments();
    //this.getTrend();
    //google.charts.load('current', { 'packages': ['corechart'] });
    this.getDashboardChart();
    this.getPraticeBMTrackingDashboardChart();
   // google.charts.setOnLoadCallback(this.practicebmdashboardchart02);
    this.loadDashboardContent();
  }
  angularGridReady(angularGrid: AngularGridInstance) {
    this.angularGrid = angularGrid;
    this.userService.angularGrid = angularGrid;
  }
  loadFilterValues() {
    
    let inpValue = new year();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 1;
    inpValue.tenantUno = 1;
    inpValue.userUno = this.login_UserID;
    this.restApi.getKPITranFilterValues(inpValue)
      .subscribe(data => {
        
        let objdata: any = data;        
        this.yearData = objdata.list_YearMaster;

        //this.onLoadDashboard();
       
        // this.spinner.hide();
      },
        (error) => {
          //Called when error
         // this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        //this.spinner.hide();
      });

  }
  getDivisions() {

    let inpValue = new division();
    inpValue.userUno = this.login_UserID ;
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 5;
    inpValue.tenantUno = 1;
    this.restApi.getDivisions(inpValue)
      .subscribe(data => {

        this.division_data = data;
      },
        (error) => {
          //Called when error
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
      });
  }

 

  onChangeDivision(e: any) {
    
   
    setTimeout(() => {
    this.getDashboardChart();
      this.getPraticeBMTrackingDashboardChart();
    }, 600);
  }

 
 

  practicebmdashboardchart01(){
    
    let tempArray = [];

    //tempArray.push(['Plan', this.progressCountList[0].planCount]);
    //tempArray.push(['Collect', this.progressCountList[0].collectCount]);
    //tempArray.push(['Adapt', '50']);
    //tempArray.push(['Analyze', '70']);






    ////const data = google.visualization.arrayToDataTable([
    ////  ['Benchmark', 'Percentage'],

    ////  ['Plan', 30],
    ////  ['Collect', 30],
    ////  ['Adapt', 20],
    ////  ['Analyze', 20]
    ////]);
    //var data = google.visualization.arrayToDataTable(tempArray);
    //const options = {
    //  //title: 'SLA Performance Summary',
    //  colors: ['#4472c4', '#43beb9', '#70ad47','#45b664'],
    //  legend: { position: 'none' },
    //  chartArea: { left: 10, top: 10, bottom: 10, width: "100%", height: "100%" }
    //};

    //const chart = new google.visualization.PieChart(document.getElementById('practice-bm-dashboard-chart01'));
    //chart.draw(data, options);

    tempArray = ([

      { name: 'Plan', value: (this.progressCountList[0].planCount != '') ? parseInt(this.progressCountList[0].planCount) : 0 },
      { name: 'Collect', value: (this.progressCountList[0].collectCount != '') ? Math.round(parseInt(this.progressCountList[0].collectCount)) : 0 },
      { name: 'Adapt', value: (this.progressCountList[0].adaptCount != '') ? Math.round(parseInt(this.progressCountList[0].adaptCount)) : 0 },
      { name: 'Analyze', value: (this.progressCountList[0].analyseCount != '') ? Math.round(parseInt(this.progressCountList[0].analyseCount)) : 0 }
    
    ]);
    let totalval = ((this.progressCountList[0].planCount != '') ? parseInt(this.progressCountList[0].planCount) : 0) +
      ((this.progressCountList[0].collectCount != '') ? Math.round(parseInt(this.progressCountList[0].collectCount)) : 0) +
      ((this.progressCountList[0].adaptCount != '') ? Math.round(parseInt(this.progressCountList[0].adaptCount)) : 0) +
      ((this.progressCountList[0].analyseCount != '') ? Math.round(parseInt(this.progressCountList[0].analyseCount)) : 0);
    var options = {
      //title: 'Progress Chart',
      color: ['#68b097', '#83ceb1', '#aaebac', '#f5d17a', '#efa96c', '#de8060', '#a44b2d', '#428893'],
      //legend: { position: 'right' },
      fontSize: 15,
      legend: {
        textStyle: {
          fontSize: 12
        },
        position: 'right'
      },
      chartArea: { left: 0, right: 0, top: 0, bottom: 10, width: "80%", height: "100%" }
    };


    //echarts starts
    this.chartOptionpracticebmdashboardchart01 = {
      tooltip: {
        trigger: "item",
        formatter: "{c}",
        textStyle: {
          fontWeight: "bold",
          fontSize: 13
        }
      },
      
      legend: {
        bottom: '0',
        left: 'center',
        //orient: "vertical",

        //padding: [
        //  20,  // up
        //  20, // right
        //  0,  // down
        //  0, // left
        //],
      },
      color: ['#68b097', '#83ceb1', '#aaebac', '#f5d17a', '#efa96c', '#de8060', '#a44b2d', '#428893'],
      series: [
        {
          name: '',
          type: 'pie',
          radius: ['30%', '80%'],
          center: ["50%", "43%"],
          avoidLabelOverlap: false,
          label: {
            show: true,
            position: 'inside',
            color: '#fff',
            fontSize: '12',
            formatter: function (d) {
              return Math.round((d.value / totalval) * 100) + '%';
            }
          },
          emphasis: {
            label: {
              show: true,
              fontSize: '10',
              fontWeight: 'bold'
            }
          },
          labelLine: {
            show: true
          },
          
          data:tempArray
        }
      ]
    };
   // echarts ends



    //var chart = new google.visualization.PieChart(document.getElementById('practice-bm-dashboard-chart01'));

    //chart.draw(data, options);
  }

  practicebmdashboardchart02 = (option_data: any) => {

    
    let tempArray = [];
    let tempArraydiv = [];

    let temparrTotalProject = [];
    let temparrTotalProjectonTrack = [];
    let temparrTotalProjectSmall = [];
    let temparrTotalProjectCritical = [];
    let temparrTotalProjectProjectCompleted = [];

    for (var i = 0; i < option_data.length; i++) {
      temparrTotalProject.push(option_data[i].totalProjects);
      temparrTotalProjectonTrack.push(option_data[i].projectOnTrack);
      temparrTotalProjectSmall.push(option_data[i].smallVariance);
      temparrTotalProjectCritical.push(option_data[i].criticalVariance);
      temparrTotalProjectProjectCompleted.push(option_data[i].projectCompleted);
      tempArraydiv.push(option_data[i].division);
    }
    tempArray.push(
      { name: 'Total Project', type: 'bar', data: temparrTotalProject }, { name: 'Project on Track', type: 'bar', data: temparrTotalProjectonTrack }, { name: 'Small varaiance', type: 'bar', data: temparrTotalProjectSmall }, { name: 'Critical variance', type: 'bar', data: temparrTotalProjectCritical }, { name: 'Project Completed', type: 'bar', data: temparrTotalProjectProjectCompleted });

    //const data = google.visualization.arrayToDataTable([
    //  ['Division', 'Total Project', 'Project on Track', 'Small varaiance', 'Critical variance', 'Project Completed'],
    //  ['Water and Civil', 50, 40, 10, 30,  35],
    //  ['Distribution Power ', 60, 50, 20, 20,  40],
    //  ['Division3', 50, 40, 20, 35,  30],
    //  ['Division4', 40, 30, 10, 25,  25],
    //  ['Strategy & Government Communication', 30, 20, 10, 15,  20]
    //]);

  //  var data = google.visualization.arrayToDataTable(tempArray);
     

    //echarts starts
    this.chartOptionpracticebmdashboardchart02 = {
      title: {
        text: '',
        subtext: ''
      },
      color: ['#68b097', '#83ceb1', '#aaebac', '#f5d17a', '#efa96c', '#de8060', '#a44b2d', '#428893'],
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow'
        }
      },
      legend: {
        data: ['Total Project', 'Project on Track', 'Small varaiance', 'Critical variance', 'Project Completed'],
        bottom: '2',
        left: 'center',
        //padding: [
        //  20,  // up
        //  0, // right
        //  0,  // down
        //  0, // left
        //],
      },
      grid: {
        left: '0',
        top: '10%',
        right: '0',
        bottom: '20%',
        containLabel: true
      },
      yAxis: {
        type: 'value',
        boundaryGap: [0, 0.01]
      },
      xAxis: {
        type: 'category',
        data: tempArraydiv
      },
      series: tempArray
    };
   // echarts ends

    //const chart = new google.visualization.ColumnChart(document.getElementById('practice-bm-dashboard-chart02'));
    //chart.draw(data, options);
  }
  getDashboardChart() {
    
    this.spinner.show();
    let inpValue = new dashboardChart();
    inpValue.id = 0;
    inpValue.userUno = this.login_UserID;
    inpValue.condition = 0;
    inpValue.division = (this.divisionUno !=null)?this.divisionUno.toString():"0";
    this.restApi.getDashboardChart(inpValue)
      .subscribe(data => {
        
        this.progressCountList = data;

        if (!(this.progressCountList[0].planCount == "0" && this.progressCountList[0].adaptCount == "0" && this.progressCountList[0].analyseCount == "0" && this.progressCountList[0].collectCount == "0")) {
          setTimeout(() => {
           this.practicebmdashboardchart01();
          }, 200);
        }
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });
  }
  getPraticeBMTrackingDashboardChart() {
    this.spinner.show();
    let inpValue = new dashboardChart();
    inpValue.id = 0;
    inpValue.userUno = this.login_UserID;
    inpValue.condition = 2;
    inpValue.division = (this.divisionUno != null) ? this.divisionUno.toString() : "0";
    this.restApi.getDashboardChart(inpValue)
      .subscribe(data => {
        
        this.practiceBMTrackingList = data;
        if (this.practiceBMTrackingList[0].objListPracticeBMTracking.length >0)
        setTimeout(() => {
          this.practicebmdashboardchart02(this.practiceBMTrackingList[0].objListPracticeBMTracking);
        }, 200);
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });
  }
  loadDashboardContent() {
    this.spinner.show();
    this.columnDefinitions = [];
    let inpValue = new dashboardContentEntry();
    inpValue.id = 0;
    inpValue.userUno = this.login_UserID;
    inpValue.condition = 0;
    this.restApi.getPraticeBMDashboard(inpValue)
      .subscribe(data => {
        
        let filterDataSet:any
        filterDataSet = uniqBy(data, 'id');
       
        this.data = filterDataSet.filter(a => a.type == this.dashboardType);
        this.projectContent = filterDataSet.filter(a => a.type == 'Project');
        this.outgoingContent = filterDataSet.filter(a => a.type == 'Outgoing');
        const mockDataset = [];
        for (let i = 0; i < this.data.length; i++) {

          mockDataset[i] = {
            id: this.data[i].id,
            title: this.data[i].title,
            type: this.data[i].type,
            enteredBy: this.data[i].enteredBy,
            enteredOn: this.data[i].enteredOn,

          };
        }
        
        this.dataset = mockDataset;
        
        if (mockDataset.length > 0) {
          
          this.setGridDefn();
          setTimeout(() => {
            this.gridShow = true;
          }, 300);
        }
        else {
            this.setGridDefn();
        }
       
        this.spinner.hide()
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });
  }
  setGridDefn() {
    let temp = this;
    this.columnDefinitions = [
      {
        id: 'title', name: 'Title', field: 'title', sortable: true, type: FieldType.string, filterable: true, width:100,
        filter: {
          collection: this.uniqueArray(this.dataset, 'topic', 'topic'),
          model: Filters.multipleSelect,

        }
      },
   

      {
        id: 'action', name: 'Action', field: 'action', cssClass: 'blue', width: 10,
        excludeFromExport: true,
        formatter: this.actionFormatter,
        cellMenu: {
          hideCloseButton: false,
          commandTitleKey: 'COMMANDS',
          commandItems: [
            {
              command: 'delete-row', titleKey: 'EDIT_ROW', positionOrder: 62, title: 'Edit',
             
              iconCssClass: 'fa fa-pencil-square-o', cssClass: 'blue', textCssClass: 'bold',
              action: (e, args) => {
                this.dashkbtn = 'Update';
                

                let rdata: any = args.dataContext;
                this.editID = rdata.id;
                this.objDashboard = rdata;
              },
              // only show command to 'Delete Row' when the task is not completed

            },
            { divider: true, command: '', positionOrder: 63 },
     
         
            {
              command: 'delete-row', titleKey: 'DELETE_ROW', positionOrder: 64, title: 'Delete',
             
              iconCssClass: 'fa fa-trash', cssClass: 'red', textCssClass: 'bold',
              action: (e, args) => {
                Swal.fire({
                  title: 'Delete',
                  text: 'Please confirm to delete the record',
                  type: 'warning',
                  showCancelButton: true,
                  confirmButtonText: 'Ok',
                  cancelButtonText: 'Cancel'
                }).then((result) => {
                  if (result.value) {
                   // this.pageAction = 'delete';
                    this.DeleteDashboardContent(args.dataContext);
                  } else if (result.dismiss === Swal.DismissReason.cancel) {

                  }
                })
              },
              // only show command to 'Delete Row' when the task is not completed

            },


          ],
        }
      }

    ]


  }
  actionFormatter: Formatter = (row, cell, value, columnDef, dataContext) => {
    return `<div class="fake-hyperlink"> <i class="fa fa-ellipsis-h fa-lg"></i></div>`;
  };
  CheckValue(val) {
    if (val != undefined && val != null && val != '' && val != ':')
      return val;
    else
      return ' ';

  }
  Checklabel(val) {
    if (val != undefined && val != null && val != '' && val != ' ')
      return val.trim();
    else
      return ''

  }
  uniqueArray(arrayList, val, label) {
    var temp = this;
    var aList = [];
    if (arrayList) {
      for (var i = 0, l = arrayList.length; i < l; i++)
        if (aList.filter(item => item.label == temp.Checklabel(arrayList[i][label])).length == 0) {

          aList.push({
            'value': this.CheckValue(arrayList[i][val]), 'label': this.Checklabel(arrayList[i][label])
          });
        }
    }


    aList.sort((a: any, b: any) => {
      if (a['value'] < b['value']) {
        return -1;
      } else if (a['value'] > b['value']) {
        return 1;
      } else {
        return 0;
      }
    });
    return aList;
  }
  DeleteDashboardContent(data1: any) {
    
    let obj = new dashboardContentEntry();
    obj.id = data1.id;
    obj.title = data1.title;
    obj.type = data1.type;
    obj.userUno = this.login_UserID;
    obj.condition = 2;
    this.restApi.addEditPraticeBMDashboard(obj)
      .subscribe(data => {
        
        if (data != null && data != undefined && data != '' && data != 'failure') {
          this.toaster.show('success', 'Success', 'Item Deleted Successfully.');
          this.spinner.hide();
          this.loadDashboardContent();
        }
        else {
          this.toaster.show('error', 'Error', 'Something went wrong');
          this.spinner.hide();
        }



      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });

  }

  onSubmit(val1) {


    if (!val1) {
      //Swal.fire('Error', 'Please enter the required information.', 'error');
      this.toaster.show('error', 'Error', 'Please enter the required information.');
      return
    }

    else {

      this.AddEditDashboardContent();
    }
  }
  AddEditDashboardContent() {
    
    
    this.dashkbtn = 'Add';
    let obj = new dashboardContentEntry();
    obj.id = (this.editID != null && this.editID != undefined) ? this.editID : 0;
    obj.userUno = this.login_UserID;
    obj.title = this.objDashboard.title;
    obj.type = this.dashboardType;
    obj.condition = (this.editID != null && this.editID != undefined) ? 1 : 0;
    
    this.restApi.addEditPraticeBMDashboard(obj)
      .subscribe(data => {
        
        if (data != null && data != undefined && data != '' && data != 'failure') {
          
          this.toaster.show('success', 'Success', 'Dashboard content saved.');
          setTimeout(() => {
            this.spinner.hide();
            this.loadDashboardContent();
            this.clearEntryForm();
          }, 900);

         
        }
        else {
          this.toaster.show('error', 'Error', 'Something went wrong');
          this.spinner.hide();
        }



      },
        (error) => {
          //Called when error
          this.spinner.hide();
          this.multipleDashboardContent = [];
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        //this.spinner.hide();
      });
  }

  onAddDashboardContent() {
    
    this.isSubmitted = true;
    this.isAddentry = false;
   
    if (this.title !='') {
      this.isAddentry = true;
      //  Swal.fire('Error', 'Please enter the required information.', 'error'); return;
      //}
      //else {
      this.isSubmitted = false;
      if (this.dashkbtn == 'Add') {
       
        let objDashboardkEntry = {
          title: this.title,
         
        }

        
        //Check Duplicate Entry
        if (!this.CheckDuplicateItem(objDashboardkEntry)) {
          this.multipleDashboardContent.push(objDashboardkEntry);
          this.clearEntryForm();
        }
        else {
          this.toaster.show('warning', 'Warning', 'Duplicate values are not allowed.');
        }



      }
      else {
        let objDashboardkEntry = {
          title: this.title,
        }

        
        //Check Duplicate Entry
        this.multipleDashboardContent.splice(this.selectedEditItemIndex, 1);
        if (!this.CheckDuplicateItem(objDashboardkEntry)) {

          this.multipleDashboardContent.push(objDashboardkEntry);
         
          this.dashkbtn = 'Add';
          this.clearEntryForm();
        }
        else {
          
          let objBenchmarkEntry = {
            title: this.title
          }

          this.multipleDashboardContent.push(objBenchmarkEntry);
          //Swal.fire('Error', 'Duplicate values not allowed.', 'error'); return;
          this.toaster.show('warning', 'Warning', 'Duplicate values are not allowed.');
        }
        //this.objTranBenchmarkKPI = new tranbenchmarkkpi();
      }
    }
    return false;
  }
  clearEntryForm() {
    this.objDashboard.title = '';
  }
  CheckDuplicateItem(objBM: any) {
    if (this.multipleDashboardContent != null && this.multipleDashboardContent != undefined) {
      
      var rtnValue = false;
      let listItems = this.multipleDashboardContent;
      let enteredItem = objBM.title;
      listItems.forEach((item) => {
        let existItem = item.title;
       
        if (enteredItem == existItem) {

          rtnValue = true;
        }

      });

      return rtnValue;
    }
  }
 
  onkeypress(e) {
    this.isSubmitted = false;
  }

  openModalWithClass(type: any) {
    this.dashboardType = type;
    
    this.loadDashboardContent();
        this.modalRef = this.modalService.show(
      this.dashboardContentAddEdit,
      Object.assign({}, {
        class: 'gray modal-lg',
        backdrop: true,
        keyboard: true,
        focus: true,
        show: false,
        ignoreBackdropClick: true,
        animated: true
      })
    );
  }
 }


